import React, { Suspense, useEffect, useState } from 'react'
import classes from "./LogsTableLayout.module.css";
import Card from "./Card";
import Table from './Table/Table';
import tableClasses from './Table/EventsTable.module.css';
import { Await, useLoaderData, useNavigate } from 'react-router-dom';
import { Oval, Bars, ThreeDots } from 'react-loading-icons';
import Modal from '../Modal/Modal';
import alarm from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Alarm - Off.svg"
import cameraOn from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Camera - On.svg"
import cameraOff from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Camera - Off.svg"
import gateOpen from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Gate - Closed.svg"
import gateClosed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Gate - Open.svg"
import doorOpen from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Door - Open Black.svg"
import doorClosed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/__Door - Closed Black.svg"
import defaultOn from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/__Sensor - On.svg"
import defaultOff from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/__Sensor - Off.svg"
import armed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/armed.png"
import disarmed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/disarmed.png"
import pulsed from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/pulsed.png"
import locked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/locked.png"
import unlocked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked.png"
import otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/OTP.png"
import input_on from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_on.png"
import input_off from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/input_off.png"
import update from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/update.png"
import add from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/add.png"
import added from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/added.png"
import used_otp from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/used_otp.png"
import unlocked_unopened from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlocked_unopened.png"
import delete_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/delete_pin.png"
import deleted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/deleted.png"
import incorrect_pin from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/incorrect_pin.png"
import linked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/linked.png"
import unlinked from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/unlink.png"
import invited from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/invited.png"
import offline from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/offline.png"
import online from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/online.png"
import not_received from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/schedule_failed.png"
import accepted from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/accepted.png"
import left from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/left.png"
import camect from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/camect.png"
import copy_users from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/copyUsers.png"
import override from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/override.png"
import warning from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Pin Icons/PinIcons/warning.png"
import changeRole from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/DropdownIcons/swap.png"
import gateway from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/gateway.png"
import expired from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/time.png"
import EventsTable from './Table/EventsTable';
import Export from '../UI/Cards/Logs Cards/Export/Export';
import BasicTable from './Table/Table';
import Button1 from '../UI/Button/Button1';
import SearchbarSmall from '../UI/Inputs/SearchbarSmall';
import { useSelector } from 'react-redux';
import ExportExcel from '../ExcelExport/ExcelExport';
import LinegraphPeaked from '../UI/Graphs/linegraphPeaked';
import { da } from 'date-fns/locale';
import { sub } from 'date-fns';

const LogsTableLayout = ({ data, isloading, Filtering }) => {

  //isloading = false;
  console.log(data)
  
  var m_names = window.innerWidth <= 1280
  ? ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"] // Abbreviated for smaller screens
  : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]; // Full names for larger screens

    function formatDate(date) {

      var sup = "";
  
      if (date.getDate() == 1 || date.getDate() == 21 || date.getDate() ==31)
      {
          sup = "st";
      }
      else if (date.getDate() == 2 || date.getDate() == 22)
      {
           sup = "nd";
      }
      else if (date.getDate() == 3 || date.getDate() == 23)
      {
          sup = "rd";
      }
      else
      {
          sup = "th";
      }
  
      var curr_month = date.getMonth();
      var curr_year = date.getFullYear();

      var hours = date.getHours();
      var minutes = date.getMinutes();
      
      var ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
       var strTime = hours + ':' + minutes + ' ' + ampm;
  
      return (date.getDate() + sup + " " + m_names[curr_month] + " " + curr_year + ", " + strTime);
  }

  const iconMapping = [
    armed,
    disarmed,
    pulsed,
    locked,
    unlocked,
    otp,
    input_off,
    input_on,
    update, 
    add, 
    added, 
    used_otp, 
    unlocked_unopened, 
    delete_pin, 
    deleted, 
    incorrect_pin, 
    linked, 
    unlinked, 
    invited, 
    offline, 
    online, 
    not_received, 
    accepted, 
    left, 
    camect, 
    copy_users, 
    override, 
    warning, 
    changeRole, 
    gateway,
    expired
  ]

  let tableData = data;
  console.log(tableData)

  const [pageSize, setPageSize] = useState(10)

  const tablecolumns = [
    {
      id: 'activity',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Activity</h3>
        </div>
      ),
      accessorKey: 'eventData',
      cell: (row) => {
        console.log(row.row.original)
        const subType = row.row.original.subType;
        const eventData = row.row.original.eventData;
        let recipientName = row.row.original.recipientName;
        if (recipientName == "Unknown"){
          recipientName = ""
        }
        const type = row.row.original.type

        let rowText;
        let iconPath;

        switch (subType) {
          case 'removed':
            rowText = recipientName + " " + subType
            break;
          case 'added':
            rowText = recipientName + " " + subType
            break;
          case 'changeRole':
            rowText = recipientName + "'s " + eventData;
            break;
          case 'suspended' :
            rowText = recipientName + " was " + eventData;
            break;
          case 'unsuspended' : 
            rowText = recipientName + " was " + eventData;
            break;
          case "OPEN_CLOSE_LOCKED":
            rowText = eventData + " relocked";
            break;
          case "OTP_UNLOCK":
            rowText = eventData + " unlocked with OTP";
            break;
          case "PIN_UNLOCK":
            rowText = eventData
            break;
          case "MASTER_PIN_UNLOCK":
            rowText = eventData + " unlocked with master PIN";
            break;
          case "UNOPENED_LOCKED":
            rowText = eventData + " unlocked but not opened";
            break;
          case "INCORRECT_PIN":
            rowText = "Incorrect PIN was attempted on " + eventData;
            break;
          case "Unlock":
            rowText = eventData + " unlocked";
            break;
          case "DELETE_PIN":
            rowText = "Pincode deleted from " + eventData;
            break;
          case "FIRST_DURATION_UNLOCK":
            rowText = "Unlocked using Duration PIN"
            break;
          case "BLE_PIN_CREATED":
            rowText = "BLE Pin created for " + eventData
            break;
          case "expired":
            rowText = recipientName + " - site access expired"
            break;
          default:
            rowText = eventData;
        }

        if (type === "Lock" || type === "IglooEvent"){
          if (subType === "Unlock"){
            iconPath = iconMapping[4]
          } else if (subType === "OPEN_CLOSE_LOCKED") {
            iconPath = iconMapping[3]
          } else if (subType === "OTP" || subType === "BLE_PIN_CREATED"){
            iconPath = iconMapping[5]
          } else if (subType === "OTP_UNLOCK" || subType === "PIN_UNLOCK" || subType === "FIRST_DURATION_UNLOCK" || subType === "FIRST_PERMANENT_UNLOCK"){
            iconPath = iconMapping[11]
          } else if (subType === "UNOPENED_LOCKED"){
            iconPath = iconMapping[12]
          } else if (subType === "DELETE_PIN"){
            iconPath = iconMapping[13]
          } else if (subType === "INCORRECT_PIN"){
            iconPath = iconMapping[15]
          } else if (subType === "LINK"){
            iconPath = iconMapping[16]
          } else if (subType === "UNLINK"){
            iconPath = iconMapping[17]
          }
        } else if (type === "Input") {
          if (subType === "Armed"){
            iconPath = iconMapping[7]
          } else {
            iconPath = iconMapping[6]
          }
        } else if (type === "output" || type == "rule") {
          if (subType === "Armed"){
            iconPath = iconMapping[0]
          } else if (subType === "Disarmed"){
            iconPath = iconMapping[1]
          } else {
            iconPath = iconMapping[2]
          }
        } else if (type === "EfentoStatus"){
          iconPath = iconMapping[27]
        } else if (subType === "update" || subType === "Link" || subType === "Update"){
          iconPath = iconMapping[8]
        } else if (subType === "add" || subType === "Set" || subType === "Add" || subType === "Added" || subType === "Linked"){
          iconPath = iconMapping[9]
        } else if (subType === "added" ){
          iconPath = iconMapping[10]
        } else if (subType === "delete" || subType === "removed" || subType === "Delete"){
          iconPath = iconMapping[14]
        } else if (subType === "LINK"){
          iconPath = iconMapping[16]
        } else if (subType === "invited"){
          iconPath = iconMapping[18]
        } else if (subType === "offline"){
          iconPath = iconMapping[19]
        } else if (subType === "online"){
          iconPath = iconMapping[20]
        } else if (type === "ScheduledAction"){
          iconPath = iconMapping[21]
        } else if (subType === "accepted"){
          iconPath = iconMapping[22]
        } else if (subType === "left"){
          iconPath = iconMapping[23]
        } else if (type === "Camect"){
          iconPath = iconMapping[24]
        } else if (subType === "copyDeviceUsers"){
          iconPath = iconMapping[25]
        } else if (subType === "Override"){
          iconPath = iconMapping[26]
        } else if (eventData === "Logs cleared"){
          iconPath = iconMapping[14]
        } else if (subType === "Unlinked"){
          iconPath = iconMapping[14]
        } else if (subType === "changeRole"){
          iconPath = iconMapping[28]
        } else if (subType == "suspended" || subType == "unsuspended"){
          iconPath = iconMapping[27]
        } else if (type == "gateway"){
          if (subType == "tamper"){
            iconPath = iconMapping[27]
          } else {
            iconPath = iconMapping[29]
          }

        } else if (type == "SiteAccess"){
          iconPath = iconMapping[30]
        }

        return (
            <div  style={{ display: "flex",  alignItems: "center", gap: "10px" }}>
              <div />
              <img className={classes.img} src={iconPath}/>
             <div className={classes.tableValueText}>
              {rowText}
              </div>
            </div> 
        )
      }
    },
    {
      id: 'time',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>Time</h3>
        </div>
      ),
      accessorKey: 'eventDate',
      cell: (row) => {
        const eventDate = new Date(row.row.original.eventDate)
        return (
          <div className={classes.tableValueText}>
            {formatDate(eventDate)}
          </div>)
      }
    },
    {
      id: 'user',
      header: () => (
        <div className={classes.tableTitleText} title="Click to sort">
          <h3>User</h3>
        </div>
      ),
      accessorKey: 'user',
      cell: (row) => {
        return (
          <div className={classes.tableValueText}>
            {row.row.original.user + ` ${row.row.original.type == "rule" ? " via Smart Rule Plus" : ""}`}
          </div>
        )
      }
    }
  ];

  const [exportData, setExportData] = useState()

  const exportFormatFunction = (event) => {
    return {
      Date: event.eventDate,
      Time: event.eventTime,
      Acivity: event.eventData,
      User: event.user
    };
  };

  return (
    <div className={classes.table}>
      <div className={classes["tableCardLayoutUI-wrapper"]}>
        <div className={classes["top-wrapper"]}>
          {/* <div className={classes["info-bar"]}>
            <>
               {isloading && <ThreeDots stroke="var(--Primary-Color)" height={50} width={25} speed={1.5} />}
            </>
           </div>  */}
        </div>
        {isloading ? <div className={classes["loadingSpinner-container"]}>  <ThreeDots stroke="var(--Primary-Color)" height={200} width={100} speed={1.5} /> </div>
          :
          <BasicTable data={tableData} columns={tablecolumns} filtering={Filtering} rowClick={false} ShowPagination={true} PageSize={pageSize} setPageSize={setPageSize} paginationOptions={[10, 50, 100]} tableClasses={tableClasses} setExportData={setExportData} exportFormatFunction={exportFormatFunction} />}
      </div>
    </div>
  )
}

export default LogsTableLayout;